/**
 * Runtime API endpoint resolver.
 *
 * The console talks to admin_service (:8502) and chat_service (:8500). Rather
 * than hard-coding a host in .env (which breaks every time the machine's LAN IP
 * changes, or when opening the console from a different device), we DERIVE the
 * host from the browser's current location. Open the console at
 * http://192.168.1.11:5173 and the API calls go to http://192.168.1.11:8502 —
 * open it from any other IP/hostname and it follows automatically.
 *
 * An explicit VITE_* env var still WINS when set, for cases where the backend
 * lives somewhere other than the host serving the frontend (a fixed prod URL,
 * an ngrok/Cloudflare tunnel, a reverse proxy). Leave the vars blank in .env to
 * use auto-detection.
 */
const ADMIN_PORT = "8502";
const CHAT_PORT = "8500";

const _loc =
  typeof window !== "undefined" && window.location
    ? window.location
    : { protocol: "http:", hostname: "localhost" };

const _host = _loc.hostname || "localhost";
const _httpProto = _loc.protocol === "https:" ? "https:" : "http:";
const _wsProto = _loc.protocol === "https:" ? "wss:" : "ws:";

const _env = import.meta.env;

export const API_BASE_URL =
  _env.VITE_API_BASE_URL || `${_httpProto}//${_host}:${ADMIN_PORT}`;

export const CHAT_SERVICE_URL =
  _env.VITE_CHAT_SERVICE_URL || `${_httpProto}//${_host}:${CHAT_PORT}`;

// Normalise the WebSocket base URL:
//  1. Strip any accidental trailing "/chat" suffix (the WS paths already include it).
//  2. On an HTTPS page, always upgrade ws:// → wss:// regardless of what the
//     env var says, to prevent Mixed Content blocks in production.
function _normaliseWsUrl(raw) {
  // Remove trailing slash then trailing /chat segment
  let url = raw.replace(/\/+$/, "").replace(/\/chat$/, "");
  // If the page is HTTPS, force the secure protocol
  if (_loc.protocol === "https:") {
    url = url.replace(/^ws:\/\//, "wss://");
  }
  return url;
}

export const WS_URL = _normaliseWsUrl(
  _env.VITE_WS_URL || `${_wsProto}//${_host}:${CHAT_PORT}`
);

// Admin base for the few call sites that used VITE_ADMIN_BASE_URL; defaults to
// the same admin_service origin as API_BASE_URL.
export const ADMIN_BASE_URL = _env.VITE_ADMIN_BASE_URL || API_BASE_URL;
